<template>
  <div>
    <RandomStyle
      ref="RandomTextArea"
      :random-word-data="RandomData"
    ></RandomStyle>
    <SimpleKeyboard
      ref="Keyboard"
      @onChange="onChange"
      @onKeyPress="onKeyPress"
      :input="input"
      :show-gesture="true"
    />
  </div>
</template>

<script>
import SimpleKeyboard from "../../SimpleKeyboard";
import RandomStyle from "../../StyleText/RandomStyle";
export default {
  name: "ShortcutsStep",
  components: {
    RandomStyle,
    SimpleKeyboard,
  },
  data() {
    return {
      input: "",
      RandomData: "Javscript",
    };
  },
  mounted() {
    this.$refs.Keyboard.compare = (btn) => {
      console.log("当前的", btn);
      this.$refs.RandomTextArea.handlerWord(btn);
      if (btn === false) {
        return true;
      }
      var ch = this.$refs.RandomTextArea.nextWord();
      return ch.includes(btn);
    };
  },
  methods: {
    onChange(input) {
      this.input = input;
      console.log(input, "input");
    },
    onKeyPress(button) {
      window.console.log("button", button);
    },
  },
};
</script>

<style lang="less" scoped></style>
